import { Box } from '@material-ui/core'
import React from 'react'
import { SummaryLineChart } from './SummaryLineChart'
import { CustomSeries } from '../calibration/chart-util'
import { FullFormatOptions } from '../../../util/formatters'

type Props = {
  energySystemData: CustomSeries[]
  xFormatter: (value: number) => string
  yFormatter: (value: number, options?: FullFormatOptions) => string
  height: number
  axisBottomLegend?: string
  axisLeftLegend?: string
  showPoints?: boolean
  legendItemWidth?: number
}

export function SummaryLineGraphContent({
  energySystemData,
  xFormatter,
  yFormatter,
  height,
  axisBottomLegend,
  axisLeftLegend,
  showPoints = false,
  legendItemWidth,
}: Props): React.ReactElement {
  // const xAxisValueFormatter = (index: number) => index.toString()

  return (
    <Box width="100%" height={height} borderRadius={6}>
      {energySystemData.length > 0 && (
        <SummaryLineChart
          data={energySystemData}
          xFormatter={xFormatter}
          yFormatter={yFormatter}
          // xAxisFormatter={xAxisValueFormatter}
          axisBottomLegend={axisBottomLegend}
          axisLeftLegend={axisLeftLegend}
          showPoints={showPoints}
          legendItemWidth={legendItemWidth}
        />
      )}
    </Box>
  )
}
